const { detect } = require('detect-browser');
const browser = detect();

document.addEventListener('DOMContentLoaded',function() {

    if (browser) {
        document.documentElement.classList.add(browser.name);
    }

    const cover = document.getElementById('cover');
    
    const init = function() {
        document.body.removeAttribute('style');
        document.body.classList.add('is-loaded');
        
        setTimeout(function() {
            cover.remove();
        }, 250);

        
        // Anims on inview
        window.animsInit();  
        
        
        // Carousels 
        document.getElementById('benefits') ? window.benefitsCarousel() : false;
        document.getElementById('insta') ? window.instaCarousel() : false;
        
        // Parallax 
        document.getElementsByClassName('js-rellax').length > 0 ? window.parallax() : false;
        
        
        // Contact form 7 checkboxes
        
    	const agree = document.getElementById('agree-1');

        if (agree) {
            
            function changeEventHandler(event) {
                                
                let icon = event.currentTarget.parentNode.parentNode.parentNode;
                
                console.log(icon);
                
                if (event.target.checked) {
                    
                    document.getElementsByClassName('wpcf7-form')[0].classList.remove('unaccepted');
                    icon.classList.add('is-checked');
                    
                }  else {
                    icon.classList.remove('is-checked');
                }
                                
                console.log(event.target.checked);
            }
            
            agree.onchange = changeEventHandler;
            
        } else {
             console.log('agree deosnt exist');
        }
    };
    
    
    window.addEventListener('load', init);

}, false);